import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LocalApiCheckService {
  private readonly LOCAL_API_URL = 'http://localhost:8080';
  private readonly TIMEOUT_MS = 3000;
  
  constructor(private http: HttpClient) {}
  
  checkLocalApiAvailability(): Observable<boolean> {
    return this.http.get(`${this.LOCAL_API_URL}/api/v1/health`, { 
      responseType: 'text',
      withCredentials: false
    }).pipe(
      timeout(this.TIMEOUT_MS),
      map(() => true),
      catchError(() => of(false))
    );
  }
  
  private cachedAvailability: boolean | null = null;
  private lastCheckTime: number = 0;
  private readonly CACHE_DURATION_MS = 60000;
  
  getCachedAvailability(): Observable<boolean> {
    const now: number = Date.now();
    
    if (this.cachedAvailability !== null && 
        (now - this.lastCheckTime) < this.CACHE_DURATION_MS) {
      return of(this.cachedAvailability);
    }
    
    return this.checkLocalApiAvailability().pipe(
      map(isAvailable => {
        this.cachedAvailability = isAvailable;
        this.lastCheckTime = now;
        return isAvailable;
      })
    );
  }
  
  clearCache(): void {
    this.cachedAvailability = null;
    this.lastCheckTime = 0;
  }
}
